import React from 'react';

type PanelSectionProps = {
  title?: React.ReactNode;
  children: React.ReactNode;
  collapsible?: boolean;
  open?: boolean;
  onToggle?: () => void;
  maxHeightClassName?: string;
  className?: string;
  titleClassName?: string;
  showDivider?: boolean;
};

const PanelSection: React.FC<PanelSectionProps> = ({
  title,
  children,
  collapsible = false,
  open = true,
  onToggle,
  maxHeightClassName = 'max-h-[500px]',
  className = 'p-3',
  titleClassName = '',
  showDivider = true,
}) => {
  // Keep titles near black so closed sections do not look disabled; open uses
  // slightly heavier weight plus a light wash for the expanded cue.
  const titleToneClassName = collapsible
    ? open
      ? 'cursor-pointer select-none font-semibold text-gray-900'
      : 'cursor-pointer select-none font-medium text-gray-900'
    : 'font-medium text-gray-900';

  return (
    <>
      {title !== undefined && (
        <div
          className={`${className}${
            collapsible && open ? ' bg-gray-50/80' : ''
          }`}
        >
          <div
            className={`flex items-center justify-between text-[13px] ${titleToneClassName} ${titleClassName}`}
            onClick={collapsible ? onToggle : undefined}
            aria-expanded={collapsible ? open : undefined}
          >
            <div>{title}</div>
            {collapsible && (
              <div
                className="flex h-5 w-5 flex-row items-center justify-center rounded text-gray-700"
                aria-hidden
              >
                {open ? '−' : '+'}
              </div>
            )}
          </div>
        </div>
      )}
      {collapsible ? (
        <div
          className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${
            open
              ? `${maxHeightClassName} bg-gray-50/80 opacity-100`
              : 'max-h-0 opacity-0'
          }`}
        >
          {children}
        </div>
      ) : (
        children
      )}
      {showDivider && <div className="border-b border-gray-300" />}
    </>
  );
};

export default PanelSection;
